/**
 * Tax classification of a billing profile.
 * Marks why invoices of this party are VAT-exempt (category E), so the
 * matching exemption reason can be preselected on invoice lines.
 */
export enum TaxClassificationEnum {
  /**
   * VAT-exempt insurance business (§4 Nr. 11 UStG).
   */
  INSURANCE = "insurance",

  /**
   * Small business without VAT (Kleinunternehmer, §19 UStG).
   */
  SMALL_BUSINESS = "small_business"
}
